import type { SxProps, Theme } from '@mui/material';

/** Card padrão da plataforma (Clínica / Evoluções) para painéis da teleconsulta. */
export const teleconsultPanelCardSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  flex: 1,
  minHeight: 0,
  borderRadius: 3,
  border: '1px solid',
  borderColor: 'divider',
  bgcolor: 'background.paper',
  boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.08)',
};

/** Coluna da página (barra superior + vídeo/evolução). */
export const teleconsultPageColumnSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: 0,
  height: { md: 'calc(100dvh - 172px)' },
  maxHeight: { md: 'calc(100dvh - 172px)' },
  overflow: 'hidden',
  bgcolor: 'transparent',
};

export const teleconsultPageSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: { xs: 'column', md: 'row' },
  gap: { xs: 1.5, md: 2 },
  p: { xs: 1, sm: 1.5, md: 2 },
  flex: 1,
  minHeight: 0,
  overflow: { md: 'hidden' },
  bgcolor: 'transparent',
};
